import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { colors } from "../utils/styles"
import { RestaurantContext } from "./restaurantContext"

const Wrapper = styled.div`
  background: ${colors.secondaryColor};
  color: ${colors.mainBlack};
  display: grid;
  font-size: clamp();
  font-weight: bold;
  height: var(--announcement-bar-height);
  letter-spacing: 2;
  place-content: center;
  position: sticky;
  text-align: center;
  text-transform: uppercase;
  top: 0;
  width: 100%;
  z-index: 9999999;
  outline: 1px solid ${colors.mainBlack};
  outline-offset: -0.5rem;
`

const AnnouncementBar = ({ text }) => {
  const { temporarilyClosed } = React.useContext(RestaurantContext)

  if (temporarilyClosed)
    return <Wrapper>Temporarily closed &mdash; See you soon!</Wrapper>

  if (text) return <Wrapper>{text}</Wrapper>

  return <></>
}

AnnouncementBar.propTypes = {
  text: PropTypes.string,
}

export default AnnouncementBar
